import { Injectable } from "@angular/core";
import { AditionalEmail, NotificationDetailsSession } from "../../api/models/notificationDetailsSession";
import { PlacardEditionRequest } from "../../api/models/placardEdit";
import { Contact } from "../../interface/upplm.placardInformation";

@Injectable()
export class NotificationDetailsHelperService {

    constructor() { }

    prepareNotificationDetailsForEdit(notificationDetails: Contact[]): NotificationDetailsSession {

        let aditionalEmails: AditionalEmail[] = notificationDetails ? notificationDetails.map((item): AditionalEmail => {
            return {
                email: item.email,
                countryLanguage: item.locale,
                validEmail: true,
                emailFlag: true,
            };
        }) : [];

        return {
            aditionalEmails: aditionalEmails,
            notifyMe: false,
            showStatusBar: true,
        } as NotificationDetailsSession;
        
    }

    prepareSaveEditionRequest(editedAditionalContacts: Contact[]): PlacardEditionRequest {

        let placardEditionRequest = new PlacardEditionRequest();

        if (editedAditionalContacts) {

            placardEditionRequest.contactDetails = editedAditionalContacts;
        }

        return placardEditionRequest;
    }
}